export default __webpack_public_path__ + "static/media/terminal.529aa6eb.svg";